<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>The Return of George Washington</title>
<link href="../styles/9780062248695_template.css" rel="stylesheet" type="text/css"/>
<section epub:type="part" title="PART 1">
<header>
<div class="hide"><hr/></div>
<div class="box">
<h2 class="h2p" id="pa1"><span class="right_1" epub:type="pagebreak" id="page_1" title="1"><a href="#/text/nav#rpa1">BOOK I</a></span></h2>
<h2 class="h2p1" id="pa1a"><a href="#/text/nav#rpa1a">From New York to Mount Vernon</a></h2>
<h2 class="h2y"><a href="#/text/nav#rpa1a">1782–1786</a></h2>
</div>
<div class="hide"><hr/></div>
</header>
<div class="pagebreak">
<p class="image1"><span class="right_1" epub:type="pagebreak" id="page_2" title="2"><img alt="image" height="400" src="images/f002.jpg" width="284"/></span></p>
<p class="caption"><i>1782 print of General George Washington during the Revolutionary War.</i></p>
</div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062248695_Part_1.vue?4c063582